/**
 * /src/js/index/enter.js -> index.html
 */

import 'ijijin_builder/stylebuild/lib/mobile.less';
import '../../style/index.less'
import HeaderTpl from '../../tpl/header/tpl';
import MiddleTpl from '../../tpl/middle/middle';
import FooterTpl from '../../tpl/footer/footer';



const header = new HeaderTpl();
const middle = new MiddleTpl();
const footer = new FooterTpl();





$('.head').prepend(header.tpl);
$('.box').append(middle.middle);
$('.box').append(footer.footer);

